import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetOfficialPlannedPlantationPlantsInputDto, OfficialPlannedPlantationPlantCreateDto, OfficialPlannedPlantationPlantDto, OfficialPlannedPlantationPlantExcelDownloadDto, OfficialPlannedPlantationPlantUpdateDto } from '../dtos/official-planned-plantation-plant/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class OfficialPlannedPlantationPlantService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: OfficialPlannedPlantationPlantCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationPlantDto>({
      method: 'POST',
      url: '/api/operational/officialPlannedPlantationPlants',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/officialPlannedPlantationPlants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/officialPlannedPlantationPlants',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationPlantDto>({
      method: 'GET',
      url: `/api/operational/officialPlannedPlantationPlants/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationPlants/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOfficialPlannedPlantationPlantsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OfficialPlannedPlantationPlantDto>>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationPlants',
      params: { officialPlannedPlantationId: input.officialPlannedPlantationId, officialPlannedPlantationName: input.officialPlannedPlantationName, plantId: input.plantId, plantTypeId: input.plantTypeId, speciesGroupId: input.speciesGroupId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: OfficialPlannedPlantationPlantExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/officialPlannedPlantationPlants/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, officialPlannedPlantationId: input.officialPlannedPlantationId, officialPlannedPlantationName: input.officialPlannedPlantationName, plantId: input.plantId, plantTypeId: input.plantTypeId, speciesGroupId: input.speciesGroupId, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationPlantDto[]>({
      method: 'GET',
      url: '/api/operational/officialPlannedPlantationPlants/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: OfficialPlannedPlantationPlantUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OfficialPlannedPlantationPlantDto>({
      method: 'PUT',
      url: `/api/operational/officialPlannedPlantationPlants/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}